import { render, staticRenderFns } from "./TabFilter.vue?vue&type=template&id=3ae846bf&scoped=true&"
import script from "./TabFilter.vue?vue&type=script&lang=coffee&"
export * from "./TabFilter.vue?vue&type=script&lang=coffee&"
import style0 from "./TabFilter.vue?vue&type=style&index=0&id=3ae846bf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae846bf",
  null
  
)

export default component.exports